export const ROLE_PERMISSIONS = [
  {
    module: 'Dashboard',
    subModule: [
      {
        module: 'Dashboard',
        permissions: [],
      },
    ],
  },
  {
    module: 'Roles and Permission',
    subModule: [
      {
        module: 'Roles and Permission',
        permissions: [],
      },
    ],
  },
  {
    module: 'Create User',
    subModule: [
      {
        module: 'Create User',
        permissions: [],
      },
    ],
  },
  {
    module: 'Inbound Process',
    subModule: [
      {
        module: 'Inbound process',
        permissions: [],
      },
    ],
  },

  {
    module: 'Inventory',
    subModule: [
      {
        module: 'Inventory',
        permissions: [],
      },
    ],
  },

  {
    module: 'Bulk Update',
    subModule: [
      {
        module: 'Bulk Update',
        permissions: [],
      },
    ],
  },

  {
    module: 'Bulk Update Entry/Item',
    subModule: [
      {
        module: 'Bulk Update Entry/Item',
        permissions: [],
      },
    ],
  },

  {
    module: 'Item History',
    subModule: [
      {
        module: 'Item History',
        permissions: [],
      },
    ],
  },

  {
    module: 'Master Data',
    subModule: [
      { module: 'Employee', permissions: [] },
      { module: 'Warehouse', permissions: [] },
      { module: 'Item Description', permissions: [] },
      { module: 'Order Type', permissions: [] },
      { module: 'Stock Type', permissions: [] },
      { module: 'Item Category', permissions: [] },
      { module: 'Storage code', permissions: [] },
      { module: 'Pallet code', permissions: [] },
      { module: 'Brand', permissions: [] },
      { module: 'Condition Code', permissions: [] },
      { module: 'Damage code', permissions: [] },
      { module: 'Workflow code', permissions: [] },
      { module: 'Activity code', permissions: [] },
      { module: 'Grading scale', permissions: [] },
      { module: 'Owner code', permissions: [] },
      { module: 'Owner group', permissions: [] },
      // { module: "Family", permissions: [] },
      { module: 'Sub-family', permissions: [] },
      { module: 'Courier mode', permissions: [] },
      { module: 'Courier partner', permissions: [] },
      { module: 'Packaging', permissions: [] },
      { module: 'Directory', permissions: [] },
      { module: 'Update status', permissions: [] },
      { module: 'Custom Fields', permissions: [] },
      { module: 'Item History Config', permissions: [] },
      { module: 'Visitor Purpose', permissions: [] },
    ],
  },
  {
    module: 'Freeze Items',
    subModule: [
      {
        module: 'Freeze Items',
        permissions: [],
      },
    ],
  },
  {
    module: 'Bundling',
    subModule: [
      { module: 'Bundle Type', permissions: [] },
      { module: 'Bundle', permissions: [] },
      { module: 'Unbundle', permissions: [] },
    ],
  },
  {
    module: 'Outbound Process',
    subModule: [
      { module: 'Pick-list', permissions: [] },
      { module: 'Create-Dc', permissions: [] },
      { module: 'Outbound', permissions: [] },
      { module: 'Reverse-Dc', permissions: [] },
    ],
  },
  {
    module: 'Shipment',
    subModule: [{ module: 'Shipment', permissions: [] }],
  },
  {
    module: 'Reports',
    subModule: [{ module: 'Reports', permissions: [] }],
  },
  {
    module: 'Billing Reports',
    subModule: [{ module: 'Billing Reports', permissions: [] }],
  },
  {
    module: 'Audit Reports',
    subModule: [{ module: 'Audit Reports', permissions: [] }],
  },
  {
    module: 'Recycle Bin',
    subModule: [{ module: 'Recycle Bin', permissions: [] }],
  },
  {
    module: 'Visitor Info',
    subModule: [{ module: 'Visitor Info', permissions: [] }],
  },
];
